import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const TourIntentContext = createContext(null);

// Holds one intent (e.g. { type: 'OPEN_TAB', component: 'profile', tabIndex: 0 }) until the
// addressed component handles it, so an intent sent just before that component mounts isn't lost.
export const TourIntentProvider = ({ children }) => {
  const [intent, setIntent] = useState(null);
  const clearIntent = useCallback(() => setIntent(null), []);
  const value = useMemo(
    () => ({ intent, broadcastIntent: setIntent, clearIntent }),
    [intent, clearIntent]
  );

  return (
    <TourIntentContext.Provider value={value}>
      {children}
    </TourIntentContext.Provider>
  );
};

export const useTourIntentContext = () => useContext(TourIntentContext);
